import tw from "twin.macro";
import { css } from "@styled-system/css";
import { TkaH3Span, TkaP2Span } from "@themes/font-tags";

export const SpacedContentsDiv = tw.div`flex gap-24 items-center`;
export const AnswerLetter = tw(TkaH3Span)``;
export const AnswerText = tw(TkaP2Span)`flex-grow text-[12px]`;
export const answerText = css({
	flexGrow: 1,
	fontSize: "12",
	lineHeight: "[2]",
});

export const answerTextWrong = css({
	color: "error.100",
});
export const answerTextCorrect = css({
	color: "success.100",
});
